import { Box, Typography, SxProps, Theme } from '@mui/material';

export interface ControllerHint {
  keys: string[];
  label: string;
  keyWeight?: 'normal' | 'bold';
}

export interface ControllerHintsProps {
  hints: ControllerHint[];
}

export const ControllerHints = ({ hints }: ControllerHintsProps) => {
  const getKeyButtonSx =
    (weight: 'normal' | 'bold'): SxProps<Theme> =>
    ({ backrs, typography }) => ({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: backrs.spacing['spacing-2xl'],
      height: backrs.spacing['spacing-2xl'],
      padding: `${backrs.spacing['spacing-sm']} ${backrs.spacing['spacing-md']}`,
      margin: `0 ${backrs.spacing['spacing-xxs']}`,
      border: `1px solid ${backrs.colors['Colors/Border/border-primary']}`,
      borderRadius: backrs.radius['radius-sm'],
      backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
      fontSize: typography['text-sm-regular']?.fontSize || '14px',
      fontWeight: weight === 'bold' ? 600 : 400,
      lineHeight: 1,
      color: backrs.colors['Colors/Foreground/fg-secondary'],
      boxShadow: `0 1px 2px rgba(0, 0, 0, 0.1)`,
    });

  return (
    <Box sx={containerSx}>
      <Box sx={hintsContainerSx}>
        {hints.map((hint, index) => (
          <Box key={index} sx={hintGroupSx}>
            {hint.keys.map((key, keyIndex) => (
              <Box key={keyIndex} component="span" sx={getKeyButtonSx(hint.keyWeight || 'bold')}>
                {key}
              </Box>
            ))}
            <Typography component="span" variant="caption" color="text.secondary" sx={labelSx}>
              {hint.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

// Styling
const containerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
};

const hintsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
});

const hintGroupSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-xs'],
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  margin: `0 ${backrs.spacing['spacing-sm']}`,
});
